import { useUserRole } from '@store/selectors/auth'
import { EUserRoles } from '@enums/roles'

const usePermissions = (roles: EUserRoles[]) => {
  const role = useUserRole()
  return roles.includes(role)
}

export default usePermissions
